import jsPsychSurveyHtmlForm from "@jspsych/plugin-survey-html-form";
import { jsPsych } from "../../taskSetup";
import i18next from "i18next";
import store from "store2";

let rt = [];
let key = [];
let startTime;

const practiceStim = (corpusName, assessment_stage_val) => {
  let stim = {
    type: jsPsychSurveyHtmlForm,
    html: () => {
      let currentItem = store.session.get("practiceItem");
      let questionHTML = `<p>` + currentItem.item + `</p>`;
      let responseHTML = ``;
      questionHTML = `<div class="question-box">` + questionHTML + `</div>`;
      if (currentItem.response_format[0] === "single") {
        responseHTML =
          `<div class="response-horizontal">
                    <input type="text" name="question_input_0" id="question_input_key_0" class="item-textbox-alpaca" style="text-align:center; width:` +
          currentItem.textbox_width +
          `;">
                </div>`;
      } else {
        responseHTML =
          `<div class="response-horizontal">
                    <p style="padding-left:5vw">` +
          currentItem.lead[0] +
          `</p>
                    <div class="fraction-practice">
                        <input type="text" name="demo_0" id="demo_key_0" value="${currentItem.demoNumbers[0]}" class="item-textbox-alpaca" style="text-align:center; width:` +
          currentItem.textbox_width +
          `;" disabled>
                        <hr>
                        <input type="text" name="demo_1" id="demo_key_1" value="${currentItem.demoNumbers[1]}" class="item-textbox-alpaca" style="text-align:center; width:` +
          currentItem.textbox_width +
          `;" disabled>
                    </div>
                    <p style="padding-left:5vw">` +
          currentItem.lead[1] +
          `</p>
                    <div class="fraction-practice">
                        <input type="text" name="question_input_0" id="question_input_key_0" class="item-textbox-alpaca" style="text-align:center; width:` +
          currentItem.textbox_width +
          `;">
                        <hr>
                        <input type="text" name="question_input_1" id="question_input_key_1" class="item-textbox-alpaca" style="text-align:center; width:` +
          currentItem.textbox_width +
          `;">
                    </div>
                </div>`;
      }

      return (
        `<div class=item-stimulus-alpaca>` +
        questionHTML +
        responseHTML +
        `<p class="warning-text" id="warning">${i18next.t("warning")}</p>
            </div>`
      );
    },
    data: {
      // Here is where we specify that we should save the trial to Firestore
      assessment_stage: assessment_stage_val,
    },
    on_start: () => {
      //initialise variables for trial
      rt = [];
      key = [];
      startTime = performance.now(); //get initial time
    },
    on_load: () => {
      document.getElementById("question_input_key_0").focus();

      //hide the survey form submit button
      const submit_button = document.getElementById(
        "jspsych-survey-html-form-next",
      );
      submit_button.classList.add("hide-submit");

      document
        .getElementById("jspsych-survey-html-form")
        .addEventListener("keydown", (event) => {
          //only permit numbers, backspace and enter key
          if (event.code === "ArrowLeft" || event.code === "ArrowUp") {
            let element = document.getElementById("question_input_key_0");
            element.focus();
            //element.setSelectionRange(element.value.length, element.value.length);
            element.selectionStart = element.value.length;
            element.selectionEnd = element.value.length;
          } else if (
            event.code === "ArrowRight" ||
            event.code === "ArrowDown"
          ) {
            let element = document.getElementById("question_input_key_1");
            element.focus();
            element.setSelectionRange(
              element.value.length,
              element.value.length,
            );
          } else if (
            event.code === "Enter" &&
            !store.session.get("warningVisible") &&
            document.getElementById("question_input_key_1")
          ) {
            let textEmpty0 =
              document.getElementById("question_input_key_0").value.trim() ===
              "";
            let textEmpty1 =
              document.getElementById("question_input_key_1").value.trim() ===
              "";
            if (textEmpty0 != textEmpty1) {
              event.preventDefault();
              document.getElementById("warning").style.visibility = "visible";
              store.session.set("warningVisible", true);
            }
          } else {
            const endTime = performance.now();
            const response_time = Math.round(endTime - startTime);
            const name = event.key;
            key.push(name);
            rt.push(response_time);
          }
        });
    },
    on_finish: (data) => {
      store.session.set("warningVisible", false);
      const stimulus = store.session.get("practiceItem");
      let response_val = [];
      let correctCount = 0;
      if (data.response) {
        for (let i = 0; i < stimulus.target.length; i++) {
          response_val.push(
            data.response["question_input_" + i].replace(/\s+/g, ""),
          );
          if (data.response["question_input_" + i] === stimulus.target[i]) {
            correctCount++;
          }
        }
      }

      if (correctCount === stimulus.target.length) {
        store.session.set("dataCorrect", 1); // if response = 1 then the participant got it correct
      } else {
        store.session.set("dataCorrect", 0); // if response = 0 then the participant got it wrong
      }

      let save_trial = true;
      let time_out = store.session("timeOut"); //will always be false

      jsPsych.data.addDataToLastTrial({
        save_trial: save_trial,
        time_out: time_out,
        corpusName: corpusName,
        pid: store.session.get("config").pid,
        trialNumBlock: store.session("practiceIndex") + 1,
        itemID: stimulus.itemID,
        item_raw: stimulus.item_raw,
        target_1: stimulus.target[0],
        target_2: stimulus.target[1] ?? "",
        correct: store.session("dataCorrect"),
        response_1: response_val[0],
        response_2: response_val[1] ?? "",
        respTime: rt,
        keyPress: key,
      });

      store.session.transact("practiceIndex", (oldVal) => oldVal + 1);
      let practiceArray = store.session.get("corpusAll").practice;
      if (practiceArray.length - 1 <= store.session.get("practiceIndex")) {
        store.session.set(
          "practiceItem",
          practiceArray[store.session.get("practiceIndex")],
        );
      }
    },
  };
  return stim;
};

export const checkPractice = (corpusName, assessment_stage_val) => {
  return {
    timeline: [practiceStim(corpusName, assessment_stage_val)],
    conditional_function: () => {
      if (
        store.session.get("indexTracking") ===
        store.session.get("practiceItem")["after_item_ID"]
      ) {
        return true;
      }
      return false;
    },
  };
};
